module.exports = __webpack_public_path__ + "static/media/all-sport-in-city.2606429b.svg";